/**
 * App-wide logger.
 *
 * Per coding-standards §16: never `console.log` in committed code. Route
 * everything through this module so we have a single place to silence in
 * production, swap for Sentry, redact PII, etc.
 *
 * Never log tokens, full request/response bodies, or anything that could
 * include credentials.
 */

const IS_DEV = process.env.NODE_ENV !== 'production';

type LogArgs = ReadonlyArray<unknown>;

export const logger = {
  info: (...args: LogArgs): void => {
    if (!IS_DEV) return;
    // eslint-disable-next-line no-console
    console.info(...args);
  },
  warn: (...args: LogArgs): void => {
    // eslint-disable-next-line no-console
    console.warn(...args);
  },
  error: (...args: LogArgs): void => {
    // eslint-disable-next-line no-console
    console.error(...args);
  },
};
